import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import HtmlPage from 'views/htmlPage/HtmlPage';
import SplitPane from 'views/splitPane/SplitPane';
import TenantsForm from 'views/tenantsForm/TenantsForm';
import TenantsList from 'views/tenantsList/TenantsList';
import Button from 'views/button/Button';

import './tenants.scss';
import URLService from "../../../service/URLService";

import tenantsStore from 'storeState/tenants';

class Tenants extends Component {

    constructor(props) {
        super(props);
    }

    onTenantSelect = (tenant_id) => {
        URLService.setQueryParameter("tenant_id", tenant_id);
        this.setState({})
    }

    handleNewClick = (tenant_id) => {
        URLService.removeQueryParameter("tenant_id");
        this.setState({})
    }

    render() {
        console.log("this.props", this.props)
        return (
            <HtmlPage className="screen-tenants" >
                <div className="content-tenants">
                    <SplitPane split="vertical" minSize={200} id="tenants" store={true}>
                        <div>
                            <div className="tenants-buttonbar">
                                <Button onClick={this.handleNewClick}>
                                    <FormattedMessage id="tenants.create" defaultMessage="Create a new tenant"  />
                                </Button>
                            </div>
                            <TenantsList
                                onTenantSelect={this.onTenantSelect}
                            />
                        </div>
                        <div>
                            <TenantsForm
                                tenant_id={URLService.getQueryParameterAsString("tenant_id")}
                            />
                        </div>
                    </SplitPane>
                </div>
            </HtmlPage>
        );
    }
}

export default connect((state, props) => {
    return {
        tenants: tenantsStore.selectors.tenantsList(state)
    }
},(dispatch, props) => {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    }
})(Tenants)


// WEBPACK FOOTER //
// ./src/components/screens/tenants/Tenants.js